import React from 'react'
import { Modal, ModalBody, ModalFooter } from 'uiComponents/popups/modal.new'
import { MembershipPayment } from 'memberships/schema'
import { CancelButton } from 'uiComponents/buttons/cancelButton'
import { DateFormats } from 'utils'
import { formatISOString } from 'utils'
import PressAndHoldButton from 'uiComponents/buttons/pressAndHoldButton'
import Currency from 'uiComponents/money/currency'
import { Trans, useTranslation } from 'translations'
import './refundPaymentModal.scss'

interface RefundPaymentModalProps {
    payment: MembershipPayment
    onClose: () => void
    onRefund: (payment: MembershipPayment) => void
}

const RefundPaymentModal: React.FC<RefundPaymentModalProps> = ({ payment, onClose, onRefund }) => {
    const { t } = useTranslation()
    const amount = <Currency amount={payment.amount} currency={payment.currency} />
    return (
        <Modal
            className="refund-payment-modal"
            title={<Trans i18nKey="memberships.membershipDetailsPanel.refundPaymentModal.title" components={{ amount }} />}
            onDismiss={onClose}
        >
            <ModalBody>
                <div>
                    <Trans
                        i18nKey="memberships.membershipDetailsPanel.refundPaymentModal.body"
                        values={{ date: formatISOString(payment.paymentDate, DateFormats.LONG_DATE) }}
                        components={{ amount }}
                    />
                </div>
                <div>{t('memberships.membershipDetailsPanel.refundPaymentModal.irreversible')}</div>
            </ModalBody>
            <ModalFooter>
                <CancelButton onClick={onClose}>{t('memberships.membershipDetailsPanel.refundPaymentModal.goBack')}</CancelButton>
                <PressAndHoldButton
                    text={t('memberships.membershipDetailsPanel.refundPaymentModal.confirm')}
                    holdTime={3000}
                    onComplete={() => onRefund(payment)}
                    destructive
                />
            </ModalFooter>
        </Modal>
    )
}

export default RefundPaymentModal
